/**
 * Dev: routed through src/setupProxy.js (see that file) to dodge the backend's
 * missing CORS headers. Prod: IIS ARR reverse-proxies the same '/backend-api'
 * prefix to the real API. REACT_APP_API_BASE_URL remains an override escape hatch.
 */
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '/backend-api';

export const IS_TEST_MODE = (process.env.REACT_APP_IS_TEST ?? 'true') === 'true';

/** reCAPTCHA v3 site key for the login page. Build-time override; the app also picks it
 *  up from `Config/GetAppConfig` post-login (too late for login itself). Empty → the
 *  login page skips the invisible v3 captcha entirely. */
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY ?? '';

/** reCAPTCHA **v2** ("Ben robot değilim" checkbox) site key. When set, the login form
 *  renders the visible widget and requires the user to solve it before submitting; the
 *  resulting token is sent to `Login` in the same `recaptchaToken` field as v3. Empty →
 *  the checkbox is not shown and the page falls back to the invisible v3 flow above. */
export const RECAPTCHA_V2_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY ?? '';

/** `GET /api/airlinestats` is the one endpoint that authenticates with an `X-Api-Key`
 *  header (vs the session model everywhere else). Empty → the Havayolu İstatistikleri
 *  page shows a "not configured" notice instead of calling. */
export const AIRLINE_STATS_API_KEY = process.env.REACT_APP_AIRLINE_STATS_API_KEY ?? '';

export const DEFAULT_TIMEOUT_MS = 30_000;
export const LONG_TIMEOUT_MS = 240_000;
